import { ApiResponse } from '../models/apiResponse';
import { CountriesResponse } from '../models/countriesModel';
import { apiRequests as requests } from './http-client';
import { FIVE_MINUTE_GET_CACHE_CONFIG } from './cache-config';

const Countries = {
  countries: () =>
    requests
      .get<
        ApiResponse<CountriesResponse[]>
      >('/v1/countries', FIVE_MINUTE_GET_CACHE_CONFIG)
      .then((response) => response.data!),
};

export default Countries;
